export { getAPIMethod } from './methods';
export * from './enumerations';

import * as enumerations from './enumerations';
import defaults, * as entities from './entities';

const PERFORMANCE_INDICATOR_DIMENSION_PROPERTIES_MAP: { [k in enumerations.PerformanceIndicatorDimension]: 'Actual' | 'Budget' | 'Forecast' | 'Goal' } = {
    [enumerations.PerformanceIndicatorDimension.ACTUAL]: 'Actual',
    [enumerations.PerformanceIndicatorDimension.BUDGET]: 'Budget',
    [enumerations.PerformanceIndicatorDimension.FORECAST]: 'Forecast',
    [enumerations.PerformanceIndicatorDimension.GOAL]: 'Goal'
};

const PERFORMANCE_INDICATOR_DIMENSION_SOURCE_PROPERTIES_MAP: { [k in enumerations.PerformanceIndicatorDimension]: 'ActualSourceID' | 'BudgetSourceID' | 'ForecastSourceID' | 'GoalSourceID' } = {
    [enumerations.PerformanceIndicatorDimension.ACTUAL]: 'ActualSourceID',
    [enumerations.PerformanceIndicatorDimension.BUDGET]: 'BudgetSourceID',
    [enumerations.PerformanceIndicatorDimension.FORECAST]: 'ForecastSourceID',
    [enumerations.PerformanceIndicatorDimension.GOAL]: 'GoalSourceID'
};

export { enumerations, entities, defaults, PERFORMANCE_INDICATOR_DIMENSION_PROPERTIES_MAP, PERFORMANCE_INDICATOR_DIMENSION_SOURCE_PROPERTIES_MAP };